var Nobia = new function () { };

$(function () {
    Nobia.General.Init();
    Nobia.LoadSvg.Init();
    Nobia.SlickSlider.Init();
    Nobia.FilterCategories.Init();
    Nobia.HeroSlider.Start({ startSlide: 1, speed: 5000, delayAfterClick: 2000 });
    Nobia.GoogleCharts.Init();
    Nobia.Navigation.Init();
    Nobia.Disclaimer.Init();
});

Nobia.LoadSvg = new function () {
    var instance = {
        Init: function () {
            $.get("/static/images/svg/site.svg", function (data) {
                var div = document.createElement("div");
                div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
                document.body.insertBefore(div, document.body.childNodes[0]);
            });
        }
    }
    return instance;
},

    Nobia.General = new function () {
        var instance = {
            Init: function () {
                //Init google charts
                google.charts.load('current', { packages: ['corechart', 'bar'] });

                $('.js-toggle-dropdown').on('click', function () {
                    $(this).next('div').slideToggle();
                });

                //Mainmenu dropdown script.

                //$('.js-showoverlay').on('mouseenter', function () {
                //    $('.c-overlay').addClass('c-overlay--toggled');
                //});

                //$('.js-showoverlay').on('mouseleave', function () {
                //    $('.c-overlay').removeClass('c-overlay--toggled');
                //});


                //Script for touchdevices on pagecards.

                $(".js-touch-overlay").on("click", function (e) {

                    var jsOverlay = $(this).find(".js-overlay");
                    var jsContent = $(this).find(".js-content");

                    if (jsOverlay.css("opacity") <= 0) {
                        jsOverlay.css({ "opacity": "0.6", "width": "100%", "height": "100%", "z-index": "1" });
                        jsContent.css("opacity", "1");
                    }
                });

                $('.js-yearDdl').on('change', function (e) {
                    e.preventDefault();
                    $(".yearvalue").val($(this).text());
                });


                //Scroll to top functions 
                if ($(window).scrollTop() > 10) {
                    $(".header").addClass("active");
                }

                $(window).on("scroll", function () {

                    if ($(window).scrollTop() > 10) {
                        $(".header").addClass("active");
                    } else {
                        //remove the background property so it comes transparent again (defined in your css)
                        $(".header").removeClass("active");
                    }
                });

                //Submit subscriptionform
                $('.button--subscribtion').on('click', function (e) {
                    e.preventDefault();

                    $(this).closest('form').submit();
                });


                //Add 
                $(document).find("table").each(function (e) {
                    $(this).wrap("<div class=\"table-container\"></div>");
                });
            }
        };
        return instance;
    };

Nobia.GoogleMaps = new function () {
    var instance = {
        Init: function (wrapperId, defaultLatitude, defaultLongitude, defaultZoom) {

            this.DefaultLongitude = defaultLongitude;
            this.DefaultLatitude = defaultLatitude;
            this.DefaultZoom = defaultZoom;
            this.CurrentlyLoadedMarkerPoints = new Array();
            this.AllMarkers = [];

            var myOptions = {
                center: new google.maps.LatLng(defaultLatitude, defaultLongitude),
                zoom: defaultZoom,
                scrollwheel: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                draggable: true
            };

            this.GoogleMap = new google.maps.Map(document.getElementById(wrapperId), myOptions);

        },

        AddMarker: function (latitude, longitude, title) {
            var point = new google.maps.LatLng(latitude, longitude);
            var map = this.GoogleMap;

            var mapLabel = "";

            var marker = new google.maps.Marker({
                position: point,
                title: title,
                label: mapLabel,
                map: map
            });

            this.CurrentlyLoadedMarkerPoints[this.CurrentlyLoadedMarkerPoints.length] = point;
            this.AllMarkers.push(marker);
        }
    };
    return instance;
};

Nobia.HeroSlider = new function () {
    var _Interval;
    var _Delay = false;
    var $buttonList = $('.js-buttonlist');
    var $buttons = $buttonList.find('a[data-target]');
    var wrapperId = $buttonList.data('wrapperid');
    var $targetWrapper = $('#' + wrapperId);

    var instance = {

        Start: function (options) {
            var defaultOptions = { startSlide: 1, speed: 1500, delayAfterClick: 1500 }; //Default om inga options finns
            var mergedOptions = $.extend({}, defaultOptions, options); //Mergat options med default

            Nobia.HeroSlider.ChangeSlide(mergedOptions.startSlide, $buttons, mergedOptions.speed); //Första sliden laddas

            //Vid tryck på respektive knapp börjar den om animationen från den knappen
            $buttons.each(function (index) {
                $(this).on("click", function (e) {
                    e.preventDefault();

                    clearTimeout(_Interval);
                    Nobia.HeroSlider.ChangeSlide(index + 1, $buttons, mergedOptions.speed, mergedOptions.delayAfterClick);
                });
            });
        },

        ChangeSlide: function (currentIndex, $buttons, speed, delayAfterClick) {
            currentIndex = currentIndex - 1;
            var totalItems = $buttons.length;

            if (currentIndex === totalItems)
                currentIndex = 0;

            var $button = $buttons.eq(currentIndex);

            //Logik för att visa och dölja med knappen som ursprung, här får du lägga in din egen som sagt
            var $currentTarget = $targetWrapper.find('#' + $button.data('target'));
            var $activeTarget = $currentTarget.siblings('.showing');
            var $currentTargetDot = $("[data-target='" + $button.data('target') + "']")
            var $activeDot = $("[data-target].active");


            $activeTarget.removeClass('showing');
            $currentTarget.addClass('showing');

            $activeDot.removeClass('active');
            $currentTargetDot.addClass('active');

            currentIndex++;

            if ($('.hero-sliderDot').length > 1) {
                if (delayAfterClick) {
                    _Interval = setTimeout(Nobia.HeroSlider.ChangeSlide, speed + delayAfterClick, currentIndex, $buttons, speed);
                    _Delay = true;
                }
                else {
                    _Interval = setTimeout(Nobia.HeroSlider.ChangeSlide, _Delay ? 0 : speed, currentIndex + 1, $buttons, speed);
                    _Delay = false;
                }
            }
        }
    };
    return instance;
};

Nobia.SlickSlider = new function () {
    var instance = {
        Init: function () {
            $(document).ready(function () {
                $('.slider').each(function () {
                    $(this).slick({
                        arrows: false,
                        dots: true,
                        appendDots: $($(this).next('.slider-dots'), '', '', $('a'), $(this)),
                        customPaging: function (slider, i) {
                            return $('<button type="button" data-role="none" role="button" tabindex="0" />');
                        }
                    });
                });
            });
        }
    };
    return instance;
};

Nobia.FilterCategories = new function () {
    var instance = {
        Init: function () {
            var $categories = $('.js-category-filter').find('a[data-categoryid]');
            var $categoryTargets = $('.js-category-targets').find('div[data-categories]');

            $categories.on('click', function (e) {
                e.preventDefault();

                var categoryId = $(this).data('categoryid');

                $categories.removeClass('checked');
                $(this).addClass('checked');

                $categoryTargets.hide();

                $categoryTargets.each(function () {
                    var categories = $(this).data('categories').toString();

                    if (categories.indexOf(categoryId) >= 0 || categoryId === 'all')
                        $(this).fadeIn('slow');
                });
            });
        }
    };
    return instance;
};

Nobia.GoogleCharts = new function () {
    var instance = {

        Init: function () {
            google.charts.setOnLoadCallback(Nobia.GoogleCharts.DrawCharts);
        },

        DrawCharts: function () {
            $("[data-chart]").each(function () {
                var sortedData;
                var colors;
                var contentId;
                var language;

                var chartData = $(this).data('chart');
                contentId = $(this).attr('id');

                $.ajax({
                    type: "GET",
                    url: "/chart/getchartdatajson",
                    data: chartData,
                    success: function (data) {
                        if (data) {
                            sortedData = JSON.parse(data.chartData);

                            if (chartData.chartType === 'pie') {
                                Nobia.GoogleCharts.DrawPie(sortedData, contentId);
                            }
                            else if (chartData.chartType === 'column') {
                                colors = JSON.parse(data.colors);
                                Nobia.GoogleCharts.DrawColumn(sortedData, colors, contentId);
                            }
                        }
                    },
                    error: function (data) {
                    }
                });

                $(window).on('resize', function () {
                    if (chartData.chartType === 'pie') {
                        Nobia.GoogleCharts.DrawPie(sortedData, contentId)
                    }
                    else if (chartData.chartType === 'column') {
                        Nobia.GoogleCharts.DrawColumn(sortedData, colors, contentId)
                    }
                });

            });
        },

        DrawPie: function (sortedData, contentId) {
            var element = document.getElementById(contentId)
            var width = $(element).closest('.module').width()

            width = Math.min(width, 345);

            var chartName = ['', ''];
            var colors = [];
            var propertyData = [chartName];

            $(sortedData).each(function () {
                colors.push($(this).attr('PropertyColor'));
                propertyData.push([$(this).attr('PropertyName'), parseInt($(this).attr('PropertyValue'))]);
            });

            var data = google.visualization.arrayToDataTable(propertyData);

            var options = {
                pieHole: 0.2,
                colors: colors,
                legend: 'none',
                enableInteractivity: true,
                width: width,
                height: width,
                pieSliceText: 'none',
                pieSliceBorderColor: "transparent",
                pieSliceTextStyle:
                {
                    color: '#DA291C',
                    bold: true,
                },
                chartArea:
                {
                    left: 10,
                    width: '90%',
                    height: '90%'
                },
                tooltip: {
                    isHtml: true,
                    ignoreBounds: true,
                    trigger: 'none'
                }
            };

            var chart = new google.visualization.PieChart(element);
            chart.draw(data, options);
        },

        DrawColumn: function (sortedData, colors, contentId) {
            var self = this;
            var element = document.getElementById(contentId);
            var width = $(element).closest('.module').width();

            var data = google.visualization.arrayToDataTable(
                sortedData
            );

            var options = {
                width: width,
                chart: {
                    title: 'Company Performance',
                    subtitle: 'Sales, Expenses, and Profit: 2014-2017',
                },
                chartArea:
                {
                    left: 50,
                    width: '85%',
                },
                tooltip: {
                    trigger: 'none'
                },
                colors: colors,
                legend: {
                    position: 'bottom',
                    alignment: 'start'
                }
            };

            var chart = new google.visualization.ColumnChart(document.getElementById(contentId));
            chart.draw(data, options);
        }
    };

    return instance;
};

Nobia.Navigation = new function () {
    var instance = {
        Init: function () {
            var $navOverlay = $("[data-navigation-overlay]");
            var $toggler = $("[data-navigation-toggler]");
            var $nav = $("[data-navigation]");
            var $expandLinks = $nav.find("[data-navigation-expand]");
            var $backLinks = $nav.find("[data-navigation-back]");
            var $navList = $nav.find("[data-navigation-list]");

            $expandLinks.each(function () {
                $this = $(this);
                $this.on("click", function (e) {
                    var $link = $(this);
                    e.preventDefault();
                    var $list = $link.closest("ul");

                    if ($link.parent().hasClass("expanded")) {
                        return false;
                    }
                    else {
                        $navList.find(".expanded").removeClass("expanded").addClass("expandedSubLevel");
                        $list.find("> li").addClass("hidden").removeClass("expanded");
                        $link.parent().removeClass("hidden").addClass("expanded");
                    }
                });
            });

            $backLinks.each(function () {
                $this = $(this);
                $this.on("click", function (e) {
                    var $link = $(this);
                    e.preventDefault();

                    $link.closest(".expanded").parent().find(".hidden").removeClass("hidden");
                    $link.closest(".expanded").removeClass("expanded");
                    $link.closest(".expandedSubLevel").removeClass("expandedSubLevel").addClass("expanded");
                });
            });

            $nav.on('click', function (e) {
                e.stopImmediatePropagation();
            })

            $toggler.on('click', function () {
                if (!$nav.hasClass('open')) {
                    $navOverlay.toggle('fast', undefined, function () {
                        $nav.toggleClass('open');
                        $('html').toggleClass('freeze');
                    });
                }
                else {
                    $nav.toggleClass('open');
                    $('html').toggleClass('freeze');
                    $navOverlay.toggle('fast');
                }
            })
        }
    }
    return instance;
}

Nobia.Disclaimer = new function () {
    var instance = {
        Init: function () {
            let currentStep = 1;
            let $disclaimer = $("[data-disclaimer]");
            let $disclaimerSteps = $disclaimer.find("[data-disclaimer-step]");
            let $nextButton = $disclaimer.find("[data-disclaimer-next]");

            if ($disclaimer.length == 0 || $disclaimerSteps.length == 0 || $nextButton.length == 0) return;

            Nobia.Disclaimer.FilterElements($disclaimerSteps, currentStep);

            $nextButton.on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();

                currentStep = $(e.currentTarget).data("disclaimer-next");

                if (currentStep == 2) {
                    let currentResidency = $('[data-disclaimer-residency]').val();
                    let currentLocation = $('[data-disclaimer-current]').val();

                    if ((currentResidency == '' || currentResidency == 'invalid') ||
                        (currentLocation == '' || currentLocation == 'invalid')) {

                        currentStep = "unauthorized";
                    }
                }

                if (currentStep == 3) {
                    let $acceptedRadio = $('[data-disclaimer-accepted]'); 

                    if ($acceptedRadio.is(':checked')) {
                        $disclaimer.submit();
                    };

                    currentStep = "unauthorized";
                }

                Nobia.Disclaimer.FilterElements($disclaimerSteps, currentStep);
            });
        },
        FilterElements: function (elements, step) {
            elements.filter(function (i, element) {
                let $currentElement = $(element);

                if ($currentElement.data("disclaimer-step") == step) {
                    $currentElement.show();
                }
                else {
                    $currentElement.hide();
                }
            });
        }
    }
    return instance;
}